const map = {
	"./archive_1/thumb.jpg": 510,
	"./archive_2/thumb.jpg": 5477,
	"./archive_3/thumb.jpg": 5244,
	"./archive_4/thumb.jpg": 7499,
	"./archive_5/thumb.jpg": 1754,
	"./archive_6/thumb.jpg": 4673,
	"./archive_7/thumb.jpg": 8920,
	"./archive_8/thumb.jpg": 3319
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2145;